__turbopack_context__.v({
  "title": "PointOfInterestCarousel-module__j84o7G__title",
});
